import { Pipe, PipeTransform } from '@angular/core';
import { IsNotNullOrEmpty } from '@apply4u/shared/helpers/common/type-safe-helpers';
import { FormatSeoUrl, FormatUrlLocation } from '@apply4u/shared/helpers/seo-helper';

@Pipe({
  name: 'JobDetailUrlSmartPipe',
  standalone: true
})
export class JobDetailUrlSmartPipe implements PipeTransform {
  constructor() {
  }

  transform(title: string, id: number): string {
    return "/jobs/" + this.GetFormattedJobDetailUrlText(title) + "/" + id;
  }

  GetFormattedJobDetailUrlText(jobTitle: string): string {
    let formattedUrl = "job";

    if (IsNotNullOrEmpty(jobTitle)) {
      //formattedUrl = FormatSeoUrl(jobTitle.trim()) + "-jobs";
      formattedUrl = FormatSeoUrl(jobTitle.trim());
      // if (IsNotNullOrEmpty(location)) {
      //   let formattedLocationText = FormatUrlLocation(location);

      //   if (IsNotNullOrEmpty(formattedLocationText)) {
      //     formattedUrl += "-in" + formattedLocationText;
      //   }
      // }

      formattedUrl = formattedUrl?.trim()?.toLowerCase();
    }

    return formattedUrl;
  }
}